import * as React from 'react'

import { observer } from 'mobx-react'

import Sidepanel from 'modules/core/components/Sidepanel'
import i18n from 'modules/core/lib/i18n'

import Content from './Content'

interface Props {
  open: boolean
  selectedDate: moment.Moment
  onClose: () => void
}

const TimeoffSidepanel = ({ open, selectedDate, onClose }: Props) => {
  return (
    <Sidepanel
      title={i18n.t('shift_management.sidepanel.title')}
      open={open}
      onClose={onClose}
      closeLabel={i18n.t('common.close')}
      overlay={false}
      width="wide"
    >
      <Content selectedDate={selectedDate} />
    </Sidepanel>
  )
}

export default observer(TimeoffSidepanel)
